import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { UpdateTeacherStudioBody } from "@shared-kernel/application/ports/teacher/teacher-repository";

export const updateTeacherStudio = createAsyncThunk<void, UpdateTeacherStudioBody, { extra: Partial<Dependencies> }>(
  "teacher/studio/update",
  async (body, { extra: { teacherRepository } }) => {
    await teacherRepository!.updateStudio(body);
  },
);
